import { useEffect, useState } from "react";
import CloseButton from "../buttons/CloseButton";
import classes from "./HistoryBox.module.scss";

const HistoryBox = ({ data, onClose, selectedDate, setSelectedDate }) => {
  const [years, setYears] = useState([]);
  const [year, setYear] = useState(selectedDate ? new Date(selectedDate).getFullYear() : null);
  const [date, setDate] = useState(selectedDate ? selectedDate : null);

  useEffect(() => {
    if (Array.isArray(data)) {
      // Extract unique years
      const uniqueYears = Array.from(
        new Set(data.map((item) => new Date(item.date).getFullYear()))
      );
      setYears(uniqueYears.sort((a, b) => b - a)); // Sort in descending order
    }
  }, [data]);

  const handleYearChange = (selectedYear) => {
    setYear(selectedYear);
    setDate("");
  };

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    setSelectedDate(selectedDate);
  };

  const generateDateOptions = () => {
    if (!year) return [];

    const filteredDates = data
      .filter((item) => new Date(item.date).getFullYear() === Number(year))
      .map((item) => {
        const d = new Date(item.date);
        return {
          date: item.date,
          time: d.getTime(),
          formattedDate: d.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
          }),
        };
      })
      .sort((a, b) => a.time - b.time);

    return filteredDates.map((item) => (
      <option key={item.date} value={item.date}>
        {item.formattedDate}
      </option>
    ));
  };

  const getDateOptions = () => generateDateOptions().map((date) => date.props.value);
  const currentIndex = getDateOptions().indexOf(date);

  const canGoToNextDate = () => currentIndex < getDateOptions().length - 1;
  const canGoToPreviousDate = () => currentIndex > 0;

  const goToNextDate = () => {
    if (canGoToNextDate()) {
      const nextDate = getDateOptions()[currentIndex + 1];
      setDate(nextDate);
      setSelectedDate(nextDate);
    }
  };

  const goToPreviousDate = () => {
    if (canGoToPreviousDate()) {
      const prevDate = getDateOptions()[currentIndex - 1];
      setDate(prevDate);
      setSelectedDate(prevDate);
    }
  };

  return (
    <div className={classes.form}>
      <CloseButton onClose={onClose} />
      <h5>History Viewer</h5>
      <div className={classes.group}>
        <select value={year} onChange={(e) => handleYearChange(e.target.value)}>
          <option value="" hidden>Select Year</option>
          {years.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
        <select value={date} onChange={(e) => handleDateChange(e.target.value)} disabled={!year}>
          <option value="" hidden>Select MM/DD</option>
          {generateDateOptions()}
        </select>
        <div className={classes.btnGroup}>
          <button
            className={classes.btn}
            onClick={goToPreviousDate}
            disabled={!canGoToPreviousDate()}
          >
            <b>←</b>
          </button>
          <button
            className={classes.btn}
            onClick={goToNextDate}
            disabled={!canGoToNextDate()}
          >
            <b>→</b>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HistoryBox;
